import React from "react";
import MultiSelectSearch from "../MultiSelectSearch";

interface UserDataFilterProps {
  availableKeys: string[];
  selectedKey: string | null;
  onSelectKey: (key: string | null) => void;
}

const UserDataFilter: React.FC<UserDataFilterProps> = ({
  availableKeys,
  selectedKey,
  onSelectKey,
}) => {
  const handleChange = (newKeys: string[]) => {
    onSelectKey(newKeys.length > 0 ? newKeys[newKeys.length - 1] : null);
  };

  return (
    <MultiSelectSearch
      options={availableKeys.map((key) => ({
        value: key,
        label: key,
      }))}
      selected={selectedKey ? [selectedKey] : []}
      onChange={handleChange}
    />
  );
};

export default UserDataFilter;